// extracted by mini-css-extract-plugin
export default {"container":"DF-z","header":"EF-z","details":"FF-z","link":"GF-z"};